export const PRODUCTION_HOST = "https://view.3playmedia.com";
export const LOCAL_HOST = "http://localhost:8787";
